import { z } from 'zod'

const TerminateContractConfigSchema = z.object({
  showingVisible: z.boolean().optional().default(true),
  showingDefault: z.enum(['tenant', 'company']).optional().default('tenant'),
  endDateLastDayOfMonth: z.boolean().default(true),
})

const DefectNoticeConfigSchema = z.object({
  enabled: z.boolean().optional().default(true),
  customDefectNoticeLinkUrl: z.string().url().optional(),
  feedback: z.boolean().optional().default(true),
  question: z.boolean().optional().default(true),
})

const ParkingSpotsConfigSchema = z.object({
  enabled: z.boolean().optional().default(false),
  showQueue: z.boolean().optional().default(true),
  contractDocumentLink: z.string().url().optional(),
  termsOfUseDocumentLink: z.string().url().optional(),
})

const StorageConfigSchema = z.object({
  enabled: z.boolean().optional().default(false),
  contractDocumentLink: z.string().url().optional(),
  termsOfUseDocumentLink: z.string().url().optional(),
})

const SaunaConfigSchema = z.object({
  enabled: z.boolean().optional().default(false),
  contractDocumentLink: z.string().url().optional(),
  termsOfUseDocumentLink: z.string().url().optional(),
})

const GymConfigSchema = z.object({
  enabled: z.boolean().optional().default(false),
  contractDocumentLink: z.string().url().optional(),
  termsOfUseDocumentLink: z.string().url().optional(),
})

const GymReservationsConfigSchema = z.object({
  enabled: z.boolean().optional().default(false),
  contractDocumentLink: z.string().url().optional(),
  termsOfUseDocumentLink: z.string().url().optional(),
})

const LaundryReservationConfigSchema = z.object({
  enabled: z.boolean().optional().default(false),
  contractDocumentLink: z.string().url().nullable().optional(),
  termsOfUseDocumentLink: z.string().url().nullable().optional(),
})

const CommonAreaReservationConfigSchema = z.object({
  enabled: z.boolean().optional().default(false),
  contractDocumentLink: z.string().url().optional(),
  termsOfUseDocumentLink: z.string().url().optional(),
})

const UserInfoConfigSchema = z.object({
  showCommunicationPreferences: z.boolean().optional().default(true),
  showElectronicServicesConsent: z.boolean().optional().default(false),
})

export const ResidentAppModuleConfigSchema = z
  .object({
    contractTerminationOnly: z.boolean().optional().default(false),
    defectNotice: DefectNoticeConfigSchema.optional().default({}),
    messaging: z.boolean().optional().default(false),
    extendedMessaging: z.boolean().optional().default(false),
    contractModification: z.boolean().optional().default(false),
    parkingSpots: ParkingSpotsConfigSchema.optional().default({}),
    storages: StorageConfigSchema.optional().default({}),
    sauna: SaunaConfigSchema.optional().default({}),
    gym: GymConfigSchema.optional().default({}),
    gymReservations: GymReservationsConfigSchema.optional().default({}),
    laundryReservation: LaundryReservationConfigSchema.optional().default({}),
    commonAreaReservations:
      CommonAreaReservationConfigSchema.optional().default({}),
    terminateContract: TerminateContractConfigSchema.optional(),
    reservationConfirmationEnabled: z.boolean().default(false),
    userInfo: UserInfoConfigSchema.optional().default({}),
  })
  .default({})

export type ResidentAppModuleConfig = z.infer<
  typeof ResidentAppModuleConfigSchema
>
